import Vue from 'vue';
import BjLogList from '@/components/BjLogList';
const BjLogListConstructor = Vue.extend(BjLogList);
const BjLogListModel = data => {
  const logDom = new BjLogListConstructor({
    el: document.createElement('div'),
  });
  document.body.appendChild(logDom.$el);
  logDom.show(data);
};

export default BjLogListModel;
